/* tslint:disable */
/* eslint-disable */
/* @relayHash a03ed1255b5d8805b29920b253c989b8 */

import { ConcreteRequest } from "relay-runtime";
export type WordListConfigContainer_SiteQueryVariables = {
    siteID: string;
};
export type WordListConfigContainer_SiteQueryResponse = {
    readonly site: {
        readonly id: string;
        readonly name: string;
        readonly wordList: {
            readonly banned: ReadonlyArray<string>;
            readonly suspect: ReadonlyArray<string>;
        } | null;
    } | null;
};
export type WordListConfigContainer_SiteQuery = {
    readonly response: WordListConfigContainer_SiteQueryResponse;
    readonly variables: WordListConfigContainer_SiteQueryVariables;
};



/*
query WordListConfigContainer_SiteQuery(
  $siteID: ID!
) {
  site(id: $siteID) {
    id
    name
    wordList {
      banned
      suspect
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteID"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "siteID"
                }
            ],
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "WordList",
                    "kind": "LinkedField",
                    "name": "wordList",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "banned",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "suspect",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "WordListConfigContainer_SiteQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "WordListConfigContainer_SiteQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "a03ed1255b5d8805b29920b253c989b8",
            "metadata": {},
            "name": "WordListConfigContainer_SiteQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '82367f0555ed0e3c821141e02bcd2707';
export default node;
